module.exports = __webpack_public_path__ + "img/wx-logo.59012a31.jpg";